import { render, staticRenderFns } from "./Igualdad.vue?vue&type=template&id=88213110&scoped=true&"
var script = {}
import style0 from "./Igualdad.vue?vue&type=style&index=0&id=88213110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88213110",
  null
  
)

export default component.exports